exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".wbinline {\n  min-height: 50px;\n  padding: 5px;\n  background-color: rgba(60, 180, 75, 0.1);\n  border: 1px solid #3cb44b;\n  border-left: 4px solid #3cb44b;\n  border-radius: 4px; }\n", ""]);

// exports
